const permission = JSON.parse(localStorage.getItem("permission"));
const initialState = permission ? { permission } : { permission: null };

export const permissions = {
  namespaced: true,
  state: initialState,
  actions: {
  },
  mutations: {
    changePermissions(state) {
      state.permission = JSON.parse(localStorage.getItem("permission"));
    },
  },
};
